import { dev } from '$app/environment';

export let API_URL = '';
export let active_backend = 'leutra';
export let start_folder = 'CMIP6_raw';

if (dev) {
	//API_URL = 'http://127.0.0.1:8000';
	API_URL = 'https://leutra.geogr.uni-jena.de/backend_geoportal';
		API_URL = 'https://sapphire.ms.wits.ac.za/backend_geoportal';
		active_backend = 'sapphire';
		start_folder = 'CCAM_raw';
} else {
	// When running in production with SSR, `window` is not available.
	// Default to the leutra backend on the server, and refine based on
	// hostname only in the browser.
	if (typeof window !== 'undefined') {
		if (window.location.hostname === 'leutra.geogr.uni-jena.de' || window.location.hostname === 'leutra.geogr.uni-jena.de') {
			API_URL = 'https://leutra.geogr.uni-jena.de/backend_geoportal';
			active_backend = 'leutra';
		} else if (window.location.hostname === 'sapphire.ms.wits.ac.za') {
			API_URL = 'https://sapphire.ms.wits.ac.za/backend_geoportal';
			active_backend = 'sapphire';
			start_folder = 'CCAM_raw';
		} else {
			API_URL = 'https://leutra.geogr.uni-jena.de/backend_geoportal';
			active_backend = 'leutra';
		}
	} else {
		API_URL = 'https://leutra.geogr.uni-jena.de/backend_geoportal';
		active_backend = 'leutra';
	}
}
